import { adminHttpClient } from '../commons/adminHttpClient'

export type DeleteCoverageProviderForMonthRequest = {
  startDate: string
  familyMemberId: string
}

const deleteCoverageProviderForMonth = (values: DeleteCoverageProviderForMonthRequest): Promise<unknown> => {
  return adminHttpClient.delete('Expenses/DeleteCoverageProviderForMonth', { data: values })
}

export default deleteCoverageProviderForMonth
